const isAuthenticated = () => {
  const sortdeskAuthenticated = localStorage.getItem("sortdeskAuthenticated");
  if (sortdeskAuthenticated) {
    return true;
  } else {
    return false;
  }
};

const login = (username, password) => {
  if (username == "demo" && password == "demo") {
    localStorage.setItem("sortdeskAuthenticated", true);
    return true;
  } else {
    return false;
  }
};

const logout = () => localStorage.removeItem("sortdeskAuthenticated");

export { isAuthenticated, login, logout };
